import { trackerConstants } from './creator';

export const trackerModuleInitialState = {
  connected: {
    metrics: null,
  },
  applied: {
    metrics: null,
  },
  hired: {
    metrics: null,
  },
  results: { loading: false },
};

const MAPPED_REDUCERS = {
  [trackerConstants.SET_CANDIDATES_CONNECTED]: (state, { payload }) => ({
      ...state,
      connected: payload,
    }),
  [trackerConstants.SET_CANDIDATES_APPLIED]: (state, { payload }) => ({
      ...state,
      applied: payload,
    }),
  [trackerConstants.SET_CANDIDATES_HIRED]: (state, { payload }) => ({
      ...state,
      hired: payload,
    }),
};

// eslint-disable-next-line default-param-last
function trackerReducer(state = trackerModuleInitialState, action) {
  const handler = MAPPED_REDUCERS[action.type];

  return handler ? handler(state, action) : state;
}

export default trackerReducer;
